<template>
    <div class="product">
        productDetail
        <van-image fit="cover" src="https://img.yzcdn.cn/vant/cat.jpeg"/>
        <van-cell-group>
            <van-cell title="单元格" value="内容" size="large" />
            <van-cell title="单元格" value="内容" label="描述信息" size="large" />
        </van-cell-group>

        <van-goods-action>
            <van-goods-action-icon icon="shop-o" text="店铺" @click="onClickIcon" />
            <van-goods-action-button type="danger" text="立即购买" @click="onClickButton"/>
        </van-goods-action>
    </div>
</template>

<script>
    export default {
        methods: {
            onClickButton() {
                this.$router.push("/product/pay");
            },
        }
    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/productDetail.vue